import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function VolumeOff({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M18.8406 16.1502L19.807 17.1166C20.772 15.6473 21.3333 13.8892 21.3333 12C21.3333 9.42263 20.2886 7.0893 18.5996 5.4003L17.6568 6.34311C19.1045 7.79082 19.9999 9.79082 19.9999 12C19.9999 13.5196 19.5763 14.9402 18.8406 16.1502Z"
        fill={iconColor}
      />
      <Path
        d="M17.3699 14.6795C17.7731 13.873 17.9999 12.963 17.9999 12C17.9999 10.3431 17.3283 8.84314 16.2426 7.75735L15.2997 8.70016C16.1442 9.54466 16.6666 10.7113 16.6666 12C16.6666 12.588 16.5578 13.1507 16.3593 13.6689L17.3699 14.6795Z"
        fill={iconColor}
      />
      <Path
        d="M13.3333 10.6429L12 9.30956V5.60944L10.1499 7.4595L9.20709 6.51669L12.1952 3.52856C12.3859 3.3379 12.6726 3.28086 12.9217 3.38405C13.1709 3.48724 13.3333 3.73033 13.3333 3.99997V10.6429Z"
        fill={iconColor}
      />
      <Path
        d="M20.9266 21.0647L2.9202 3.05823L1.97742 4.00101L5.97638 7.99997H3.33329C2.9651 7.99997 2.66663 8.29845 2.66663 8.66664V15.3333C2.66663 15.7015 2.9651 16 3.33329 16H7.72382L12.1952 20.4714C12.3859 20.662 12.6726 20.7191 12.9217 20.6159C13.1709 20.5127 13.3333 20.2696 13.3333 20L13.3333 15.3569L19.9839 22.0075L20.9266 21.0647ZM3.99996 9.3333L7.30971 9.3333L12 14.0235V18.3905L8.47136 14.8619C8.34634 14.7369 8.17677 14.6666 7.99996 14.6666H3.99996L3.99996 9.3333Z"
        fill={iconColor}
      />
    </Svg>
  );
}
